import { UserRole } from "@/__generated__/globalTypes"
import { ListItemText } from "@material-ui/core"
import React from "react"

const Roles = [
  {
    value: UserRole.admin,
    label: (
      <ListItemText
        primary="Admin"
        secondary="Full access including user management"
      />
    )
  },
  {
    value: UserRole.user,
    label: (
      <ListItemText
        primary="User"
        secondary="Read and write access but no user management"
      />
    )
  },
  {
    value: UserRole.readonly,
    label: (
      <ListItemText
        primary="Readonly"
        secondary="User can view data but not edit"
      />
    )
  }
]

export default Roles
